// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "notifications-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_initial-state_dist_index_esm_js-node_modules_nextcloud_moment_-4efa53":"eca0fd3077d6383c674f","node_modules_moment_locale_sync_recursive_-src_NotificationsApp_vue":"a86a9c4199ab5047e419"}[chunkId] + "";
};